/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTeamBody
 */
export interface CreateTeamBody {
    /**
     * Team name (max 50 chars)
     * @type {string}
     * @memberof CreateTeamBody
     */
    name: string;
    /**
     * Minimum members required (default 1)
     * @type {number}
     * @memberof CreateTeamBody
     */
    minMembers?: number;
    /**
     * Maximum members allowed (default 5)
     * @type {number}
     * @memberof CreateTeamBody
     */
    maxMembers?: number;
}

/**
 * Check if a given object implements the CreateTeamBody interface.
 */
export function instanceOfCreateTeamBody(value: object): value is CreateTeamBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateTeamBodyFromJSON(json: any): CreateTeamBody {
    return CreateTeamBodyFromJSONTyped(json, false);
}

export function CreateTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'minMembers': json['minMembers'] == null ? undefined : json['minMembers'],
        'maxMembers': json['maxMembers'] == null ? undefined : json['maxMembers'],
    };
}

export function CreateTeamBodyToJSON(json: any): CreateTeamBody {
    return CreateTeamBodyToJSONTyped(json, false);
}

export function CreateTeamBodyToJSONTyped(value?: CreateTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'minMembers': value['minMembers'],
        'maxMembers': value['maxMembers'],
    };
}

